import React, { FC } from "react";

import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  width: string;
  height: string;
  fill?: string;
  className?: string;
}

const Twitter: FC<Props> = ({
  className,
  height,
  width,
  fill = colors.lapel,
}) => {
  return (
    <Svg
      className={className}
      height={height}
      width={width}
      viewBox="0 0 16 16"
      title="Twitter icon"
    >
      <path
        fill={fill}
        d="M16.21.26c-.66.4-1.39.7-2.17.85A3.37 3.37 0 0011.54 0a3.47 3.47 0 00-3.33 4.3A9.63 9.63 0 011.16.65a3.57 3.57 0 001.06 4.69 3.35 3.35 0 01-1.55-.44v.04c0 1.7 1.18 3.12 2.74 3.44a3.26 3.26 0 01-1.54.06c.43 1.4 1.7 2.41 3.2 2.44A6.75 6.75 0 010 12.32a9.52 9.52 0 005.24 1.58c6.3 0 9.74-5.35 9.74-9.98l-.01-.46a7.03 7.03 0 001.7-1.81 6.7 6.7 0 01-1.96.55 3.5 3.5 0 001.5-1.94"
      />
    </Svg>
  );
};

export default React.memo(Twitter);
